<template>
  <nuxt-layout>
    <div class="error-page">
      <div v-if="error" class="l-container">
        <h1>{{ error.statusCode }}</h1>
        <h2>{{ $t(`errors.${error.statusCode}.subtitle`) }}</h2>
        <p>{{ $t(`errors.${error.statusCode}.message`) }}</p>
        <div class="error-page__actions">
          <button label="Go back home" @click="navigateTo($localePath('/'))">
            Go back home
          </button>
        </div>
      </div>
    </div>
  </nuxt-layout>
</template>

<script setup>
const error = useError();

onUnmounted(() => clearError());
</script>

<style lang="scss">
.error-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;

  > .l-container {
    align-items: center;
    align-content: center;
    text-align: center;

    h1,
    h2,
    p {
      grid-column: span 12;

      @include mq(desktop) {
        grid-column: 5 / span 4;
      }
    }

    h1 {
      @include title-xxl;
    }

    h2 {
      text-transform: uppercase;
    }

    p {
      margin: 96px 0;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 25px;
    grid-column: 3 / span 8;
  }
}
</style>
